import Paper from '@material-ui/core/Paper';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { parseQuery } from 'Services/parseQuery';
import Layout from '../../../common/components/Layout';
import { SimpleBreadcrumbs } from '../../../common/components/SimpleBreadcrumbs';
import { TableList } from '../../../common/components/TableList';
import { updateRankingRule } from '../../tournaments/rankingRules/actions';
import { fetchRankingRules } from '../actions';
import Row from './Row';

@injectIntl
@connect((store, props) => ({
  rankingRules: store.rankingRules.list,
  fetching: store.rankingRules.fetching,
  query: parseQuery(props.location.search),
}))
export default class RankingRules extends Component {
  config = {
    headers: [
      { labelKey: 'field_name' },
      { labelKey: 'field_targetDescription' },
      { labelKey: 'field_metaImportUuid' },
    ],
  };

  componentDidMount() {
    const { location } = this.props;
    this.fetchData(location.search);
  }

  componentWillReceiveProps(nextProps) {
    const { location: oldLocation } = this.props;
    const { location } = nextProps;

    if (oldLocation.search !== location.search) {
      this.fetchData(location.search);
    }
  }

  fetchData = filter => {
    const { dispatch } = this.props;
    dispatch(fetchRankingRules(filter));
  };

  handleChange = rankingRule => {
    const { dispatch } = this.props;
    return dispatch(updateRankingRule(rankingRule.id, rankingRule));
  };

  render() {
    const {
      rankingRules,
      fetching,
      query,
      intl: { messages: m },
    } = this.props;

    return (
      <Layout
        id="ranking_rules-layout"
        top={<SimpleBreadcrumbs crumbStack={[{ labelKey: 'app_rankingRulesReferential' }]} />}
        main={
          <Paper elevation={2}>
            <Toolbar>
              <Typography variant="h6">{m.app_rankingRulesReferential}</Typography>
            </Toolbar>
            <TableList
              tableData={rankingRules}
              tableHeaders={this.config.headers}
              query={query}
              Row={Row}
              rowCallback={this.handleChange}
              loading={fetching}
            />
          </Paper>
        }
      />
    );
  }
}
